module.exports = __webpack_public_path__ + "static/media/add-app-block-ssr.e85c5908.png";